import PropTypes from 'prop-types';
import React, { memo } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import Modal from '../Modal';

function ViewDenyCourseEnrollmentRequestModal({ id, courseEnrollment }) {
  const isConfirmButtonDisabled = () => {
    return true;
  };

  const handleConfirm = () => {};

  return (
    <Modal
      id={id}
      icon="pe-7s-info"
      iconGradient="bg-green-blue-top"
      title="Feedback denial course enrollment request"
      contentClass="modal-body-center-h"
      confirmText="SAVE"
      confirmButtonDisabled={isConfirmButtonDisabled()}
      confirmHandler={handleConfirm}>
      <div style={{ width: '100%' }}>
        <div style={{ width: '100%' }}>
          <div
            className="width100"
            style={{ border: '1px solid #ccc', padding: '8px', borderRadius: '4px', minHeight: '100px' }}
            dangerouslySetInnerHTML={{ __html: courseEnrollment.motivationDenyRequest }}></div>
        </div>
      </div>
    </Modal>
  );
}

ViewDenyCourseEnrollmentRequestModal.propTypes = {
  id: PropTypes.string.isRequired,
  courseEnrollment: PropTypes.object.isRequired,
};

export default memo(ViewDenyCourseEnrollmentRequestModal);
